function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
import * as React from 'react';
export var NestedMenuContext = /*#__PURE__*/React.createContext({
  addMenuToNesting: function addMenuToNesting() {},
  removeMenuFromNesting: function removeMenuFromNesting() {},
  // @ts-expect-error todo(flow->ts): incorrect default value
  getParentMenu: function getParentMenu() {},
  // @ts-expect-error todo(flow->ts): incorrect default value
  getChildMenu: function getChildMenu() {},
  nestedMenuHoverIndex: -1,
  isNestedMenuVisible: function isNestedMenuVisible() {
    return false;
  },
  mountRef: {
    current: null
  }
});

function isSame(a, b) {
  if (!a || !b) {
    return false;
  }

  return a.isSameNode(b);
}

var NestedMenus = /*#__PURE__*/function (_React$Component) {
  _inherits(NestedMenus, _React$Component);

  var _super = _createSuper(NestedMenus);

  function NestedMenus() {
    var _this;

    _classCallCheck(this, NestedMenus);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      menus: [],
      nestedMenuHoverIndex: -1
    });

    _defineProperty(_assertThisInitialized(_this), "mountRef", /*#__PURE__*/React.createRef());

    _defineProperty(_assertThisInitialized(_this), "mouseLeaveTimeoueId", null);

    _defineProperty(_assertThisInitialized(_this), "handleMenuMouseLeave", function (event) {
      _this.mouseLeaveTimeoueId = setTimeout(function () {
        _this.setState({
          nestedMenuHoverIndex: -1
        });
      }, 200);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMenuMouseEnter", function (event) {
      if (typeof document !== 'undefined') {
        clearTimeout(_this.mouseLeaveTimeoueId);

        var index = _this.state.menus.findIndex(function (m) {
          return m.current && event.currentTarget instanceof Node && m.current.contains(event.currentTarget);
        });

        _this.setState({
          nestedMenuHoverIndex: index
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addMenuToNesting", function (ref) {
      // check offsetHeight to determine if component is visible in the dom (0 means hidden)
      // we need to do this so that when we renderAll, the hidden seo-only child-menus don't
      // register themselves which would break the nesting logic
      var element = ref.current;

      if (element && element.offsetHeight) {
        element.addEventListener('mouseenter', _this.handleMenuMouseEnter);
        element.addEventListener('mouseleave', _this.handleMenuMouseLeave);

        _this.setState(function (state) {
          return {
            menus: [].concat(_toConsumableArray(state.menus), [ref])
          };
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeMenuFromNesting", function (ref) {
      _this.setState(function (state) {
        var _iterator = _createForOfIteratorHelper(_this.state.menus),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var r = _step.value;

            if (r.current && isSame(r.current, ref.current)) {
              var element = r.current;
              element.removeEventListener('mouseenter', _this.handleMenuMouseEnter);
              element.removeEventListener('mouseleave', _this.handleMenuMouseLeave);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var nextMenus = state.menus.filter(function (r) {
          return r.current && !isSame(r.current, ref.current);
        });
        return {
          menus: nextMenus
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "findMenuIndexByRef", function (ref) {
      return _this.state.menus.findIndex(function (r) {
        return isSame(r.current, ref.current);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getParentMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) - 1;
      return _this.state.menus[index];
    });

    _defineProperty(_assertThisInitialized(_this), "getChildMenu", function (ref) {
      var index = _this.findMenuIndexByRef(ref) + 1;
      return _this.state.menus[index];
    });

    _defineProperty(_assertThisInitialized(_this), "isNestedMenuVisible", function (ref) {
      var index = _this.findMenuIndexByRef(ref);

      return index <= _this.state.nestedMenuHoverIndex;
    });

    return _this;
  }

  _createClass(NestedMenus, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(NestedMenuContext.Provider, {
        value: {
          addMenuToNesting: this.addMenuToNesting,
          removeMenuFromNesting: this.removeMenuFromNesting,
          getParentMenu: this.getParentMenu,
          getChildMenu: this.getChildMenu,
          isNestedMenuVisible: this.isNestedMenuVisible,
          nestedMenuHoverIndex: this.state.nestedMenuHoverIndex,
          mountRef: this.mountRef
        }
      }, /*#__PURE__*/React.createElement(React.Fragment, null, this.props.children, /*#__PURE__*/React.createElement("span", {
        ref: this.mountRef
      })));
    }
  }]);

  return NestedMenus;
}(React.Component);

export { NestedMenus as default };